// アコーディオンの要素
let $trigger = $('.js_accordion_trigger');
let $target = $('.js_accordion_target');

// アコーディオン
$trigger.on('click', function () {
    let $this = $(this);
    // トリガーの親要素を取得
    let $parent = $this.closest('li');
    // ターゲットを取得
    let $target = $parent.find('.js_accordion_target');
    // ターゲットの表示・非表示処理
    $this.toggleClass('is_open');
    $target.slideToggle(250);
  })

  // 固定ボタン
  $(window).on("scroll", function() {
    if ($(this).scrollTop() > 150) {
      $(".lp_fix_btn_wrap").fadeIn();
    } else {
      $(".lp_fix_btn_wrap").fadeOut();
    }
  });

  $('.lp_buy_coupon').click(function() {
    var text = 'tsuitsui2301';
    var tempInput = document.createElement("input");
    tempInput.style = "position: absolute; left: -1000px; top: -1000px";
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
    alert(text + "をコピーしました！");
  });

  // スクロール移動
  $(".link_to_lp_main_cta").click(function() {
    $('html, body').animate({
      scrollTop: $("#lp_main_cta").offset().top
    }, 300);
  });